import React from "react";

const PropertyContent = () => {
  return (
    <div className="my-16 mx-16 py-10 rounded-2xl text-center border">
      <div>
        <h3 className="mb-8 text-themeColor">
          How to buy property in Thailand
        </h3>
      </div>
      <div
        className="my-20 text-medium font-medium"
        style={{ paddingLeft: "30px", paddingRight: "30px" }}
      >
        <p className="my-8">
          Thailand offers a wealth of opportunities for property investment.
          Whether you're looking for a vacation home, rental property, or a
          permanent residence, there's something for everyone in this tropical
          paradise. Buying property in Thailand is a straightforward process,
          but it's important to understand the legal requirements and
          regulations before making a purchase. First, you'll need to secure a
          valid non-immigrant visa, which can be obtained through a Thai embassy
          or consulate in your home country. Once you have your visa, you can
          start your property search. It's important to work with a reputable
          real estate agent or developer who can guide you through the process
          and help you find the perfect property. Next, you'll need to secure
          financing if you're not paying in cash. Many banks in Thailand offer
          mortgages for foreign buyers, and you can also look into obtaining a
          loan from an international lender. Once financing is secured, you can
          move forward with the purchase process.The final step is to transfer
          the ownership of the property to your name. This requires signing a
          sales and purchase agreement, transferring the funds, and registering
          the property in your name at the Land Department. Buying property in
          Thailand can be a great investment, and with the right guidance, the
          process can be relatively smooth. Contact us today to learn more about
          how you can own a piece of paradise in Thailand.
        </p>
      </div>
    </div>
  );
};

export default PropertyContent;
